import { render, staticRenderFns } from "./billDetial.vue?vue&type=template&id=69963cdc&scoped=true&"
import script from "./billDetial.vue?vue&type=script&lang=js&"
export * from "./billDetial.vue?vue&type=script&lang=js&"
import style0 from "./billDetial.vue?vue&type=style&index=0&id=69963cdc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69963cdc",
  null
  
)

export default component.exports